/* Polyfills leves usados no browser */

// Algumas libs podem acessar `process.env` em runtime no browser.
// Garante que `process` exista para evitar ReferenceError.
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = { env: {} };
}

